import { Component, Input } from '@angular/core'

@Component({
    selector: 'app-empty-state-screen',
    styleUrls: ['empty-state-screen.scss'],
    templateUrl: 'empty-state-screen.html'
})
export class EmptyStateScreenComponent {
    @Input() intoBoxMessage: string
    @Input() placeholderCards = 3
    @Input() useAvatarPlaceholder = false
}
